import { render } from "./AloneData.vue?vue&type=template&id=5b87d744&scoped=true"
import script from "./AloneData.vue?vue&type=script&lang=js"
export * from "./AloneData.vue?vue&type=script&lang=js"

import "./AloneData.vue?vue&type=style&index=0&id=5b87d744&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b87d744"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/AloneData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b87d744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b87d744', __exports__)) {
    api.reload('5b87d744', __exports__)
  }
  
  module.hot.accept("./AloneData.vue?vue&type=template&id=5b87d744&scoped=true", () => {
    api.rerender('5b87d744', render)
  })

}


export default __exports__